import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import '@/stylus/main.styl'

// blue -  #4168af  65, 104, 175
// green - #68af41  104, 175, 65
// purp -  #8941af  137, 65, 175

Vue.use(Vuetify, {
  theme: {
    primary: '#4168af',
    secondary: '#68af41',
    accent: '#8941af',
    error: '#8941af',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  customProperties: true,
  iconfont: 'fa'
})

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let func = function(evt) {
      if (binding.value(el)) {
        el.removeEventListener('scroll', func)
      }
    }
    binding.value(el)
    el.addEventListener('scroll', func)
  }
})
